import { useEffect, useState } from "react";
import { showToast } from "./toastUtils";

type BackgroundExportMessages = {
  success: string;
  error: string;
};

type ExportListener = (count: number) => void;

let activeExportCount = 0;
const listeners = new Set<ExportListener>();

export const getActiveExportCount = (): number => activeExportCount;

export const subscribeExportStatus = (listener: ExportListener): (() => void) => {
  listeners.add(listener);
  listener(activeExportCount);
  return () => {
    listeners.delete(listener);
  };
};

const notifyListeners = () => {
  listeners.forEach((listener) => listener(activeExportCount));
};

export const useBackgroundExportStatus = (): { isExporting: boolean; count: number } => {
  const [count, setCount] = useState(activeExportCount);

  useEffect(() => {
    return subscribeExportStatus((newCount) => {
      setCount(newCount);
    });
  }, []);

  return {
    isExporting: count > 0,
    count,
  };
};

export const runBackgroundExport = (
  job: () => Promise<void>,
  messages: BackgroundExportMessages,
): Promise<void> => {
  activeExportCount++;
  notifyListeners();

  return job()
    .then(() => {
      showToast(messages.success);
    })
    .catch((e) => {
      console.error(e);
      showToast(messages.error, "error");
      throw e;
    })
    .finally(() => {
      activeExportCount = Math.max(0, activeExportCount - 1);
      notifyListeners();
    });
};
